import FetchFactory from '../factory';
import type {PaginatedDataResult, Comment, DataWrapped} from "~/repository/types";
import CommentModel from '../models/Comment'

class CommentsRepository extends FetchFactory {
    private RESOURCE = '/comments';

    async get(postId: number, page: number | undefined, parent: number | undefined = undefined): Promise<PaginatedDataResult<Comment>> {
        const paginatedData = await this.call<PaginatedDataResult<Comment>>(
            'GET',
            `${this.RESOURCE}/${postId}`,
            {
                page: page,
                for: parent
            }
        )

        return {
            ...paginatedData,
            data: paginatedData.data.map(CommentModel.create)
        }
    }

    async create(postId: number, message: string, reply_to: number | undefined = undefined) {
        const {data: comment} = await this.call<DataWrapped<Comment>>('post', `${this.RESOURCE}/${postId}`, {
            message,
            parent_id: reply_to
        })
        return new CommentModel(comment)
    }

    async like(comment: Comment) {
        return await this.call<{
            is_liked: boolean,
            likes_count: number
        }>('post', `${this.RESOURCE}/${comment.id}/like`)
    }
}

export default CommentsRepository;